// src/Dashboard/pages/user/Absences/components/AbsencesEmptyState.jsx

import React from "react";
import { FaUserSlash } from "react-icons/fa";

export default function AbsencesEmptyState() {
  return (
    <div className="rounded-[24px] border border-dashed border-slate-300 bg-slate-50 px-5 py-12 text-center dark:border-slate-700 dark:bg-slate-900/40">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-white text-slate-400 shadow-sm ring-1 ring-slate-200 dark:bg-slate-950 dark:ring-slate-700">
        <FaUserSlash className="text-2xl" />
      </div>

      <h3 className="mt-5 text-lg font-bold text-slate-900 dark:text-white">
        Aucun adhérent associé
      </h3>

      <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-slate-500 dark:text-slate-400">
        Aucun adhérent n’est rattaché à votre compte. Vous ne pouvez donc pas
        signaler d’absence pour le moment.
      </p>
    </div>
  );
}